import { render, staticRenderFns } from "./overview-expander-document-exchange.vue?vue&type=template&id=3d786c59&scoped=true"
import script from "./overview-expander-document-exchange.vue?vue&type=script&lang=ts"
export * from "./overview-expander-document-exchange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d786c59",
  null
  
)

export default component.exports